export interface AdherenceValue {
  adherence: number | null;
}

export interface AdherenceMetrics {
  average: number | null;
  measuredCount: number;
  lowCount: number;
  highCount: number;
}

/** Ignora pacientes sem registro; mantém zero como uma medição válida. */
export function getAdherenceMetrics(values: AdherenceValue[]): AdherenceMetrics {
  const measured = values
    .map(({ adherence }) => adherence)
    .filter((value): value is number => value !== null && Number.isFinite(value));

  if (measured.length === 0) {
    return { average: null, measuredCount: 0, lowCount: 0, highCount: 0 };
  }

  return {
    average: Math.round(measured.reduce((sum, value) => sum + value, 0) / measured.length),
    measuredCount: measured.length,
    lowCount: measured.filter((value) => value < 50).length,
    highCount: measured.filter((value) => value >= 80).length,
  };
}
